import React, { useState, useEffect } from "react";
import {
  getAllPartySearch,
  getAllGeneralLedger,
} from "../../api/endpoints/search";
import {
  getVoucher,
  getTransactionId,
  saveData,
  getData,
  updateReceipt,
  deleteSingleReceipt,
  deleteReceipt,
  descReceipt,
  ascReceipt,
  onePreData,
  oneNextData,
} from "../../api/endpoints/receipts";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import SideBar from "../sidebar/sideBar";
import "./receipts.css";
import { authSelector } from "../../store/selectors/index";
import { Modal, message } from "antd";
import { Button, Dropdown, Select, Menu } from "antd";
import { useSelector } from "react-redux";
import { EMeters } from "../../enums/meters";
import Popup from "../modals/Popup";
import { latestDate } from "../../api/endpoints/meter";
import { getSiteRefrence } from "../../api/endpoints/refrences";

const { Option } = Select;

const Receipts = () => {
  const { user, access_token } = useSelector(authSelector);
  const [typeLast, setTypeLast] = useState("");

  const [voucher, setVoucher] = useState();
  const [voucherType] = useState("CV");
  const [transactionId, setTransactionId] = useState();
  const [type, setType] = useState("ADD");
  const [dateEntered, setDateEntered] = useState("");
  const [shift, setShift] = useState("");
  const [itemsQueue, setItemsQueue] = useState([]);
  const [editedItem, setEditedItem] = useState(null);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [total, setTotal] = useState();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  console.log(type, "type");

  // -------------------------- STATE ----------

  const [state, setState] = useState({
    parties: [],
    partyId: "", //ac no.
    partyName: "", // supplier name
    ledgerCodes: [],
    glCode: "",
    glDescription: "",
    description: "",
    invoiceNo: "",
    credit: "",
    cheque: "",
    transactionIdInc: "",
  });

  const clearState = () => {
    setState({
      parties: state.parties,
      partyId: "",
      partyName: "",
      ledgerCodes: state.ledgerCodes,
      glCode: "",
      glDescription: "",
      description: "",
      invoiceNo: "",
      credit: "",
      cheque: "",
    });
  };

  const clearStates = () => {
    clearState();
    setTypeLast("");
    setEditedItem(null);
    setFieldsShow(false);
    setItemsQueue([]);
    setShift("");
    setDateEntered("");
    setVoucher("");
    setTotal(0);
    setType("ADD");
  };

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  const getLatestDate = async () => {
    const _date = await latestDate(access_token);
    setDateEntered(_date.data.enteredOn);
    setShift(_date.data.shift);
    // console.log(_date, "Dateee");
  };
  useEffect(() => {
    getLatestDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ------------------- ADD VOUCHER ---------------

  const addVoucher = async () => {
    if (!dateEntered) return message.error("Please type date !");
    const payload = {
      enteredOn: dateEntered,
    };
    const result = await getVoucher(payload, access_token);
    const transactionId = await getTransactionId(access_token);
    console.log(result, "result");
    if (result.success) {
      setVoucher(result.data);
      setType("SAVE");
      setFieldsShow(true);
    } else {
      message.error(result.message);
    }
    if (transactionId.success) {
      setTransactionId(transactionId.data);
    }
    console.log(transactionId.data, "trannass");
  };
  // ------------------ SAVE DATA -----------------
  console.log(state, "state-=-=-=", type);

  const [allowedShift, setAllowedShift] = useState();
  const getRefrences = async () => {
    const _refrences = await getSiteRefrence(access_token);
    setAllowedShift(_refrences.data.allowedShift);
  };

  useEffect(() => {
    getRefrences();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  const save = async () => {
    if (!shift) return message.error("Please type shift!");
    if (shift > allowedShift)
      return message.error(`Your allowed shifts are ${allowedShift}`);
    if (itemsQueue.length === 0) return message.error("Add minimun 1 Entry");
    setIsButtonDisabled(true);

    const payload = itemsQueue.reduce((acc, curr) => {
      return [
        ...acc,
        {
          enteredOn: dateEntered,
          shift: Number(shift),
          partyId: Number(curr.partyId),
          description: curr.description,
          invoiceNumber: curr.invoiceNo,
          generalLedgerCode: curr.glCode,
          credit: Number(curr.credit),
          cheque: curr.cheque,
          transactionId: Number(curr.transactionIdInc),
          voucherNumber: Number(voucher),
          voucherType: voucherType,
          grpId: Number(user.grpId),
          siteId: Number(user.siteId),
          companyCode: Number(user.companyCode),
          approved: user.authorized === true ? true : false
        },
      ];
    }, []);

    try {
      const result = await saveData(payload, access_token);
      if (result.success) {
        clearStates();
        message.success(result.message || "Successfully entered!");
      } else {
        message.error(result.message || "Failed to save!");
      }
    } catch (error) {
      console.error("Error while saving:", error);
    } finally {
      setIsButtonDisabled(false); // Re-enable the button after the async operation completes

      // Enable the button again, whether the API call succeeds or fails
    }
  };

  // ---------------- ALL ITEMS ----------------

  const getAllData = async () => {
    const _parties = await getAllPartySearch(access_token);
    const _ledgerCodes = await getAllGeneralLedger(access_token);
    setState({
      ...state,
      parties: _parties,
      ledgerCodes: _ledgerCodes,
    });
  };
  useEffect(() => {
    getAllData();
    if (itemsQueue.length === 0) return;

    let creditSum = itemsQueue.reduce(
      (arr, curr) => arr + Number(curr?.credit || 0),
      0
    );
    setTotal(Number(creditSum));

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsQueue]);

  console.log(total, "totttt");

  // ---------------------- ADD ITEM TO QUEUE --------------

  const addItem = () => {
    if (!(state.partyId || state.glCode) || !state.credit || !state.description) { 
      return message.error(
        `Please type ${
          !(state.partyId || state.glCode)
            ? "account number or GL code"
            : !state.credit
            ? "credit amount"
            : !state.description
            ? "description"
            : ""
        }`
      );
    } else {
      state.transactionIdInc = transactionId + 1;
      setItemsQueue([...itemsQueue, state]);
      setTransactionId(state.transactionIdInc);
      console.log(transactionId, "trid-=-=--=");
      clearState();

      const nextInput = inputRefs["accountName"];
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  console.log(itemsQueue, "items queue-=-=--=");
  // -------- EDIT ITEM

  const editItem = async () => {
    if (state.id) {
      await updateSingleApi();
    } else {
      itemsQueue[editedItem] = state;
      setItemsQueue([...itemsQueue]);
      setEditedItem(null);
      clearState();
    }
  };

  // -------- EDIT ITEM

  const deleteItem = (index) => {
    // const prevObject = itemsQueue[i]
    itemsQueue.splice(index, 1);
    setItemsQueue([...itemsQueue]);
    setEditedItem(null);
    console.log("deleteItem");
    clearState();
  };

  // ---------------------- EDIT API ------------------

  const [editPopup, setEditpopup] = useState(false);
  const edit = () => {
    setEditpopup(true);
  };

  const editHandler = async () => {
    if (!voucher) return message.error("Please type voucher number!");
    const results = await getData(voucher, access_token);
    if (results.success) {
      console.log(results, "ressaaaaa");
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.party?.partyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            description: curr.description,
            invoiceNumber: curr.invoiceNo,
            glCode: Number(curr.generalLedgerCode),
            glDescription: curr.chartOfAccount.description,
            partyName: partyName,
            credit: Number(curr.credit),
            cheque: curr.cheqNumber,
            transactionIdInc: Number(curr.transactionId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setEditpopup(false);
      setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  // ---------------------- EDIT SINGLE API ------------------

  const updateSingleApi = async () => {
    const payload = {
      id: state.id,
      transactionId: state.transactionIdInc,
      partyId: Number(state.partyId),
      description: state.description,
      cheqNumber: state.cheque,
      credit: Number(state.credit),
      invoiceNumber: state.invoiceNo,
      generalLedgerCode: Number(state.glCode),
    };

    console.log(payload, "payyyyyyyyy");
    const response = await updateReceipt(payload, access_token);
    if (response.success) {
      await editHandler();
      message.success(response.message);
      clearState();
      setFieldsShow(false);
    } else {
      message.error(response.message);
    }
  };

  // ---------------- DELETE PURCHASE

  // -------- single

  const [modal, contextHolder] = Modal.useModal();
  const deleteSinglePurchase = async (transactionIdInc) => {
    console.log("deleteSingle");
    const results = await deleteSingleReceipt(transactionIdInc, access_token);
    if (results.success) {
      if (itemsQueue.length !== 1) {
        await editHandler();
      } else {
        setItemsQueue([]);
      }
      message.success("Record Deleted Successfully !");
      // clearStates()
    } else {
      message.error(results.message);
    }
  };

  const confirmDelete = (transactionIdInc) => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Record?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deleteSinglePurchase(transactionIdInc),
    });
  };

  // -------- whole data

  const [deletePopup, setDeletepopup] = useState(false);
  const deletePurchase = () => {
    setDeletepopup(true);
  };

  const deletePurchaseHandler = async () => {
    const results = await deleteReceipt(voucher, access_token);
    if (results.success) {
      clearStates();
      message.success("Record Deleted Successfully !");
      clearStates();
      setDeletepopup(false);
    } else {
      message.error(results.message);
    }
  };
  const handleBoth = async () => {
    confirmDeleteAll(); // shows the modal
    // If you also want to call editHandler *without* waiting for confirmation, you can call it here
   await editHandler(); // but probably not what you want
  };
  const confirmDeleteAll = () => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Voucher?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deletePurchaseHandler(),
    });
  };

  //----------------order by desc----------------------
  const descVoucher = async () => {
    const results = await descReceipt(access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.party?.partyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            description: curr.description,
            invoiceNumber: curr.invoiceNo,
            glCode: Number(curr.generalLedgerCode),
            glDescription: curr.chartOfAccount.description,
            credit: Number(curr.credit),
            cheque: curr.cheqNumber,
            partyName: partyName,
            voucher: Number(curr.voucherNumber),
            transactionIdInc: Number(curr.transactionId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].voucherNumber);
      setShift(results.data[0].shift);
      setTypeLast(EMeters.LAST);
      console.log(itemsQueue, "dsiiiiii");

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const ascVoucher = async () => {
    const results = await ascReceipt(access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.party?.partyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            description: curr.description,
            invoiceNumber: curr.invoiceNo,
            glCode: Number(curr.generalLedgerCode),
            credit: Number(curr.credit),
            cheque: curr.cheqNumber,
            voucher: curr.voucherNumber,
            glDescription: curr.chartOfAccount.description,
            partyName: partyName,
            transactionIdInc: Number(curr.transactionId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].voucherNumber);
      setShift(results.data[0].shift);
      setTypeLast(EMeters.LAST);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const onePreVoucher = async () => {
    let data = {
      voucherNumber: voucher,
    };
    const results = await onePreData(data, access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.party?.partyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            description: curr.description,
            invoiceNumber: curr.invoiceNo,
            glCode: Number(curr.generalLedgerCode),
            glDescription: curr.chartOfAccount.description,
            partyName: partyName,
            credit: Number(curr.credit),
            cheque: curr.cheqNumber,
            voucher: curr.voucherNumber,
            transactionIdInc: Number(curr.transactionId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].voucherNumber);
      setShift(results.data[0].shift);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const oneNextVoucher = async () => {
    let data = {
      voucherNumber: voucher,
    };
    const results = await oneNextData(data, access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.party?.partyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            description: curr.description,
            invoiceNumber: curr.invoiceNo,
            glCode: Number(curr.generalLedgerCode),
            glDescription: curr.chartOfAccount.description,
            partyName: partyName,
            credit: Number(curr.credit),
            cheque: curr.cheqNumber,
            voucher: curr.voucherNumber,
            transactionIdInc: Number(curr.transactionId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].voucherNumber);
      setShift(results.data[0].shift);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const menu = (index) => {
    return (
      <Menu>
        <Menu.Item key="0">
          <button
            onClick={() => {
              setFieldsShow(true);
              setEditedItem(index);
              setState(itemsQueue[index]);
              console.log(itemsQueue, "edit");
            }}
          >
            <AiFillEdit className="mr-2 mt-1" />

            <span>Edit</span>
          </button>
        </Menu.Item>
        {type === "SAVE" ? (
          <Menu.Item key="1">
            <button
              onClick={() => {
                deleteItem(index);
              }}
            >
              {" "}
              Delete
            </button>
          </Menu.Item>
        ) : (
          <Menu.Item key="1">
            <button
              onClick={() => {
                confirmDelete(itemsQueue[index].transactionIdInc);
              }}
            >
              {" "}
              Delete
            </button>
          </Menu.Item>
        )}
      </Menu>
    );
  };

  const inputRefs = {};
  const addInputFieldRef = (ref, fieldName) => {
    if (ref && fieldName) {
      inputRefs[fieldName] = ref;
    }
  };
  const handleEnterKey = (e, fieldName) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior of the "Enter" key

      // Trigger addItem function if the current field is "amount"
      if (fieldName === "credit") {
        Boolean(editedItem != null) ? editItem() : addItem();
      } else {
        const currentFieldName = fieldName;

        // Define the order of input fields
        const fieldOrder = [
          "dateEntered",
          "shift",
          "accountName",
          "glCode",
          "description",
          "invoiceNo",
          "cheque",
          "credit",
          // Add more field names as needed
        ];

        // Find the index of the current field in the order array
        const currentIndex = fieldOrder.indexOf(currentFieldName);
        console.log(currentIndex, "current Inddd");
        if (currentIndex !== -1 && currentIndex < fieldOrder.length - 1) {
          // Move focus to the next input field
          const nextFieldName = fieldOrder[currentIndex + 1];
          const nextInput = inputRefs[nextFieldName];

          if (nextInput) {
            nextInput.focus();
          }
        }
      }
    }
  };

  return (
    <div className="flex  bg-black recive-main">
      <SideBar />
      <div className="h-full  flex flex-col content-center  w-full">
        <div className="meterTableMain ml-10 mt-6o mr-10">
          {contextHolder}
          <div className="bg-blue-500 headingBox flex justify-between">
            <h3 className=" text-white tableHeading pl-10">
              CASH RECEIPT ENTRY
            </h3>
          </div>
          <div className="bg-blue-500">
            <div
              className="flex content-center  ml-10 pb-3"
              style={{
                display: "flow-root",
              }}
            >
              <input
                readOnly
                value={voucher}
                className="inpTxt inpTxtVoucher p-2 h-9  mb-3 w-40"
              />
              <input
                type="date"
                value={dateEntered}
                className="text-black inpTxt p-2 h-9 ml-3 mb-3 w-40"
                onChange={(e) => setDateEntered(e.target.value)}
                onKeyDown={(e) => handleEnterKey(e, "dateEntered")}
                ref={(ref) => addInputFieldRef(ref, "dateEntered")}
              />
              <input
                type="number"
                name="shift"
                value={shift}
                placeholder="Shift"
                className=" text-black inpTxt p-1 h-9 ml-3 w-52"
                onChange={(e) => setShift(e.target.value)}
                onKeyDown={(e) => handleEnterKey(e, "shift")}
                ref={(ref) => addInputFieldRef(ref, "shift")}
              />
              {fieldsShow && (
                <>
                  <Select
                    showSearch
                    className=" bg-white  inpTxtVoucher text-white ml-3 mt-5 inpTxt  p-1 h-9  w-52"
                    placeholder="Supplier Name"
                    optionFilterProp="children"
                    value={state.partyName || "Supplier Name"}
                    onChange={(e) => {
                      const { PartyName, chartOfAccount } = state.parties.find(
                        (el) => el.partyId === e
                      );
                      setState({
                        ...state,
                        partyId: e,
                        partyName: PartyName,
                        glCode: chartOfAccount.generalLedgerCode,
                        glDescription: chartOfAccount.description,
                      });
                    }}
                  >
                    {state.parties.map((el) => (
                      <Option value={el.partyId}>{el.PartyName}</Option>
                    ))}
                  </Select>

                  <Select
                    showSearch
                    disabled={Boolean(state.partyId)}
                    className="ant-select ant-select ant-select border-0 bg-white text-white ml-3 mt-5 inpTxt  p-1 h-9  w-52"
                    placeholder="GL Description"
                    optionFilterProp="children"
                    value={state.glDescription || "GL Description "}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.generalLedgerCode === e
                      );
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.description,
                      });
                    }}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option value={el.generalLedgerCode}>
                        {el.description}
                      </Option>
                    ))}
                  </Select>
                </>
              )}
            </div>
          </div>
          {fieldsShow && (
            <div className="">
              <div className="flex content-center flex-wrap mb-1 ml-10">
                <div className="">
                  <Select
                    showSearch
                    placeholder="A/C No."
                    name="accountNumber"
                    className="ant-select  bg-black text-white  inpTxt mt-5 p-1 h-9  w-52"
                    optionFilterProp="children"
                    value={state.partyId || "A/C No."}
                    onChange={(e) => {
                      console.log("e", e);

                      const _party = state.parties.find(
                        (el) => el.partyId === e
                      );
                      if (_party) {
                        setState({
                          ...state,
                          partyId: e,
                          partyName: _party.PartyName,
                          glCode: _party.chartOfAccount.generalLedgerCode,
                          glDescription: _party.chartOfAccount.description,
                        });
                      } else {
                        setState({
                          ...state,
                          partyId: e,
                          partyName: "",
                          glCode: "",
                          glDescription: "",
                        });
                      }
                    }}
                    onKeyDown={(e) => handleEnterKey(e, "accountName")}
                    ref={(ref) => addInputFieldRef(ref, "accountName")}
                  >
                    <Option value={0}>None</Option>
                    {state.parties.map((el) => (
                      <Option
                        value={el.partyId}
                      >{`${el.partyId} - ${el.PartyName}`}</Option>
                    ))}
                  </Select>
                </div>

                <div className="">
                  <Select
                    showSearch
                    name="glcode"
                    disabled={Boolean(state.partyId)}
                    className="ant-select ant-select bg-black text-white ml-3 mt-5 inpTxt  p-1 h-9  w-64"
                    placeholder="Credit GL Code"
                    optionFilterProp="children"
                    value={state.glCode || "Credit GL Code"}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.generalLedgerCode === e
                      );
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.description,
                      });
                    }}
                    onKeyDown={(e) => handleEnterKey(e, "glCode")}
                    ref={(ref) => addInputFieldRef(ref, "glCode")}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option value={el.generalLedgerCode}>
                        {`${el.generalLedgerCode} - ${el.description}`}
                      </Option>
                    ))}
                  </Select>
                </div>
                <input
                  type="text"
                  name="description"
                  value={state.description}
                  onChange={onChangeText}
                  placeholder="Description"
                  className=" ant-select bg-black text-white  mt-5 inpTxt pt-3  p-1 h-9 ml-3 w-52"
                  onKeyDown={(e) => handleEnterKey(e, "description")}
                  ref={(ref) => addInputFieldRef(ref, "description")}
                />
                <input
                  type="text"
                  name="invoiceNo"
                  value={state.invoiceNo}
                  onChange={onChangeText}
                  placeholder="Invoice No"
                  className="ant-select bg-black text-white  mt-5 inpTxt pt-3 p-1 h-9 ml-3 w-28"
                  onKeyDown={(e) => handleEnterKey(e, "invoiceNo")}
                  ref={(ref) => addInputFieldRef(ref, "invoiceNo")}
                />
                <input
                  type="text"
                  name="cheque"
                  value={state.cheque}
                  onChange={onChangeText}
                  placeholder="Chq/DD"
                  className="ant-select bg-black text-white mt-5  inpTxt pt-3 p-1 h-9 ml-3 w-24"
                  onKeyDown={(e) => handleEnterKey(e, "cheque")}
                  ref={(ref) => addInputFieldRef(ref, "cheque")}
                />

                <input
                  type="number"
                  name="credit"
                  value={state.credit}
                  onChange={onChangeText}
                  placeholder="Credit"
                  onKeyDown={(e) => handleEnterKey(e, "credit")}
                  ref={(ref) => addInputFieldRef(ref, "credit")}
                  className="ant-select bg-black text-white  mt-5 inpTxt pt-3 p-1 h-9 ml-3 w-28"
                />
                {Boolean(editedItem != null) ? (
                  <button
                    onClick={editItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white  mt-5 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillEdit className="mr-2 mt-1" />

                    <span>Edit</span>
                  </button>
                ) : (
                  <button
                    onClick={addItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-5  p-1 h-9 ml-3 w-20 rounded"
                  >
                    <span> + Add</span>
                  </button>
                )}
              </div>
            </div>
          )}

          <div className="div">
            <div className="flex">
              <div
                className=" shadow-md sm:rounded-lg tableDiv p-5 pl-10  w-full"
                style={{ overflow: "auto", maxHeight: "350px" }}
              >
                <table className=" w-full text-sm  text-left text-gray-500 dark:text-gray-400">
                  <thead className="bg-blue-500  text-white uppercase dark:bg-gray-700 tableHeading  dark:text-gray-400">
                    <tr>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        SNo.
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        GL CODE
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        GL DESCRIPTION
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Party
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Party Name
                      </th>

                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        DESCRIPTION
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Invoice
                      </th>

                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Cheque/DD
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Credit
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        ACTION
                      </th>
                    </tr>
                  </thead>
                  <tbody className="tableBody">
                    {itemsQueue.map((ele, i) => {
                      return (
                        <tr key={i} className="tbodyData text-white">
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            {i + 1}
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.glCode}</p>
                          </td>{" "}
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.glDescription}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.partyId}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.partyName}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.description}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.invoiceNo}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.cheque}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.credit}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <Dropdown overlay={menu(i)} placement="bottomLeft">
                              <Button>Action</Button>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="pr-5 flex justify-end">
            <input
              type="text"
              readOnly
              placeholder=""
              name=""
              id=""
              value={total}
              className="mt-2 pl-3 pt-1 pb-1 w-32 bg-black text-white outline-none"
            />
          </div>
          <div className="pl-9 pb-2 flex justify-between">
            <div className="flex">
              {type === "ADD" && (
                <button
                  onClick={addVoucher}
                  className="bg-blue-500 hover:bg-blue-700 h-9 flex text-white mt-3 py-1 px-4 rounded"
                >
                  <AiFillFileAdd className="mr-2 mt-1" />

                  <span>Add</span>
                </button>
              )}

              {type === "SAVE" && (
                <button
                  onClick={save}
                  className={`bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 py-1 px-4 rounded ${
                    isButtonDisabled ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  disabled={isButtonDisabled}
                >
                  <AiFillSave className="mt-1 mr-2 " />
                  <span>Save</span>
                </button>
              )}

              {type === "ADD" && (
                <button
                  onClick={edit}
                  className="bg-blue-500 hover:bg-blue-700 h-9 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                >
                  <AiFillEdit className="mr-2 mt-1" />

                  <span>Edit</span>
                </button>
              )}

              <button
                onClick={() => deletePurchase()}
                className="bg-blue-500 hover:bg-blue-700 h-9 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                disabled={type !== "ADD"}
              >
                <AiFillDelete className="mr-2 mt-1" />

                <span>Delete</span>
              </button>
              <button
                onClick={() => {
                  clearStates();
                }}
                className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 h-9 ml-3 py-1 px-4 rounded"
              >
                <BiExit className="mr-2 mt-1" />
                {type === "EDIT" ? "Done" : "Exit"}
              </button>
            </div>
            <div className="flex content-end mt-3 bg-white justify-end"></div>

            <div className="pr-5">
              <button
                onClick={ascVoucher}
                className="bg-blue-500 hover:bg-blue-700 text-white mt-3 py-1 px-4 rounded"
              >
                <img src={`./img/first.png`} alt="" />
              </button>
              {typeLast === "LAST" && (
                <button
                  onClick={onePreVoucher}
                  className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                >
                  <img src={`./img/previous.png`} alt="" />
                </button>
              )}
              {typeLast === "LAST" && (
                <button
                  onClick={oneNextVoucher}
                  className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                >
                  <img src={`./img/next.png`} alt="" />
                </button>
              )}
              <button
                onClick={descVoucher}
                className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
              >
                <img src={`./img/latest.png`} alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Popup popup={editPopup} handlePopup={setEditpopup} onOk={editHandler}>
        <div>
          <h2>Please type voucher number</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      </Popup>

      <Popup
        popup={deletePopup}
        handlePopup={setDeletepopup}
        onOk={handleBoth}
      >
        <div>
          <h2>Please type voucher number for delete record</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      </Popup>
    </div>
  );
};

export default Receipts;
